/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   actions
 */

const SET_HOVERED_CLUSTER_ITEM = 'SET_HOVERED_CLUSTER_ITEM'

export const setHoveredClusterItem = (item: any) => {
  return {
    type: SET_HOVERED_CLUSTER_ITEM,
    payload: item,
  }
}
